/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrimaryButton from '../Buttons/PrimaryButton';

import FormInput from './FormInput';
import SecondaryButton from '../Buttons/SecondaryButton';
import axios from 'axios';


const FormPlacesNearByInput = (props) => {

    const serverURL = process.env.REACT_APP_SERVER_URL;

    const defaultState = {
        range: '',
        places: ''
    }

    const [data, setData] = useState([]);
    const [currItem, setCurrItem] = useState(defaultState)
    const [editMode, setEditMode] = useState(false);

    const rangeChangeHandler = (event) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                range: event.target.value
            }
        })
    }

    const placesChangeHandler = (data) => {
        setCurrItem((prevState) => {
            return {
                ...prevState,
                places: data.value
            }
        })
    }

    const addNewHandler = () => {

        if (!currItem || !currItem.range || currItem.length === 0 || !currItem.places || currItem.places === 0) {
            toast.error("This didn't work. 😞");
            return;
        }

        setData((prevState) => {
            const newData = [...prevState];
            newData.push(currItem);
            return newData
        })

        setCurrItem(defaultState)
    }

    const editPlacesHandler = (itemToEdit, idx) => {
        setCurrItem({
            idx,
            ...itemToEdit
        });
        setEditMode(true);
    }

    const deletePlaceHandler = (idx) => {
        const newData = [...data];
        newData.splice(idx, 1);
        setData(newData)
    }

    const saveEditHandler = () => {

        if (!currItem || !currItem.range || currItem.length === 0 || !currItem.places || currItem.places === 0) {
            toast.error("This didn't work. 😞");
            return;
        }

        setData((prevState) => {
            const newData = [...prevState];
            newData[currItem.idx] = {
                range: currItem.range,
                places: currItem.places
            };
            return newData
        })

        setEditMode(false)
        setCurrItem(defaultState)
    }

    useEffect(() => {

        const getSiteData = async (id) => {
            const res = await axios({
                method: 'GET',
                url: `${serverURL}/api/sites/${id}`
            })
            setData(res.data.data.placesNearBy);
        }

        if (props.propertyID && props.propertyID.length !== 0) {
            getSiteData(props.propertyID);
        }

    }, [])

    useEffect(() => {
        props.onChange(data);
    }, [data])

    return (
        <Fragment>
            <div className='places-near-by' >
                <div className='heading-div' >
                    <div className="places-nearby-form" >
                        <FormInput autoComplete='off' id='new-range' label='Location Range' type='text' value={currItem.range} onChange={rangeChangeHandler} />
                        <FormInput id='new-places' label='Near By Places' type='editor' value={currItem.places} onChange={placesChangeHandler} />
                        {!editMode && <PrimaryButton type='button' onClick={addNewHandler} >Add</PrimaryButton>}
                        {editMode && <PrimaryButton type='button' onClick={() => {
                            saveEditHandler()
                        }} >Save Edit</PrimaryButton>}
                    </div>
                </div>
                <div>
                    {
                        data.map((item, idx) => {
                            return (
                                <Accordion key={item.range} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`${item.range}-content`}
                                        id={`${item.range}-header`}
                                    >
                                        <Typography variant='h4' >{item.range}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='places-list' dangerouslySetInnerHTML={{ __html: item.places }}></div>
                                        <div className='col-2 mt-10'>
                                            <div className='row' style={{gap:'1rem'}}>
                                                <SecondaryButton type='button' onClick={() => {
                                                    editPlacesHandler(item, idx);
                                                }} >Edit</SecondaryButton>
                                                <PrimaryButton type='button' onClick={() => {
                                                    deletePlaceHandler(idx);
                                                }} >Delete</PrimaryButton>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })
                    }
                </div>
            </div>
        </Fragment>
    )

}

export default FormPlacesNearByInput;